import React from "react";
import "../../style/navbar.css";

const Navbar = ()  => {
    return (
        <div className="navbar">
            <div className="navbar-title"> My Note's</div>
        </div>
    );
};

export default Navbar;